export class TrialInformation {
  public introductionEnabled: boolean;
  public trialInformationEnabled: boolean;
  public translations: TrialInformationTranslation[] = [];
  constructor(init?: Partial<TrialInformation>) {
    Object.assign(this, init);
    if (init && init.translations && init.translations.length > 0) {
      this.translations = init.translations.map(t => new TrialInformationTranslation(t));
    }
  }
}
export class TrialInformationTranslation {
  public culture: string;
  public introductionTitle: string;
  public introductionMessage: string;
  public trialInformation: string;
  constructor(init?: Partial<TrialInformationTranslation>) {
    Object.assign(this, init);
  }
}
